import { PayloadAction } from '@reduxjs/toolkit';
import { DTOWordWithRelatedWords } from '@shared/dto/+word/word_with_related_words/dto_word_with_related_words';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { StateWords } from './state_words';

export const local_words_with_related_words_upsert = (payload: DTOWordWithRelatedWords[]): PayloadAction<DTOWordWithRelatedWords[]> => ({
  type: ENUM__redux_action.WORDS_WITH_RELATED_WORDS_UPSERT,
  payload,
});

export const init_local_words_with_related_words_upsert = (state: StateWords, action: PayloadAction<DTOWordWithRelatedWords[]>) => {
  if (action.payload.is_empty()) return;

  for (let item of action.payload) {
    state.words_with_related_words_map.set(item.word_english, item);
  }

  //need to force re-render
  state.words_with_related_words_map = new Map(state.words_with_related_words_map);
};
